import { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { getAuthToken, clearAuthData } from '@/core/auth';
import { authApi } from '@/features/auth/api';
import { useSession } from '@/store/session';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = () => {
  const navigate = useNavigate();
  const { isAuthenticated, token } = useAuth();
  const { setSession, clearSession } = useSession();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const validate = async () => {
      const storedToken = token || getAuthToken();
      if (!storedToken) {
        clearAuthData();
        clearSession();
        navigate('/login', { replace: true });
        return;
      }

      try {
        const user = await authApi.me();
        // Garante que a sessão esteja preenchida
        setSession(storedToken, user);
      } catch {
        clearAuthData();
        clearSession();
        navigate('/login', { replace: true });
        return;
      } finally {
        if (isMounted) setChecking(false);
      }
    };

    validate();
    return () => {
      isMounted = false;
    };
  }, [token, navigate, setSession, clearSession]);

  if (checking)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center gap-3 text-muted-foreground" role="status" aria-live="polite">
          <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
          <span>Verifying session…</span>
        </div>
      </div>
    );

  // Se chegou até aqui, temos token válido
  return <Outlet />;
};
